import { Icon } from '@/app/common/icons/Icon';

import type { IconColorToken } from '@/app/common/icons/Icon';

export function IconCheck() {
  return <Icon category="Semantics" name="icon-circle-solid-check" size={20} color="iconSuccess" alt="check" />;
}

export function IconCross({ size = 20 }: { size?: number | string }) {
  return (
    <Icon
      category="Semantics"
      name="icon-circle-solid-cross"
      size={typeof size === 'number' ? size : parseInt(size, 10) || 20}
      color="iconDisabled"
      alt="cross"
    />
  );
}

const EXTERNAL_LINK_COLORS: Record<string, IconColorToken> = {
  gray200: 'iconDisabled',
  gray400: 'iconSecondary',
};

export function IconExternalLink({ color }: { color?: string }) {
  return (
    <Icon
      category="Arrows"
      name="icon-external-link"
      size={16}
      color={color ? (EXTERNAL_LINK_COLORS[color] ?? 'iconSuccess') : 'iconSecondary'}
      alt="external link"
    />
  );
}

export function IconFilters() {
  return <Icon category="UI Essentials" name="icon-filter" size={16} color="iconOnDark" alt="filters" />;
}

export function IconSorting({ opaque = false }: { opaque?: boolean }) {
  return (
    <Icon
      category="UI Essentials"
      name="icon-sort"
      size={16}
      color={opaque ? 'iconPrimary' : 'iconOnDark'}
      alt="sorting"
    />
  );
}
